var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-jobview-container afu-bg-gray-100 afu-flex afu-flex-wrap afu-py-12"},[_vm._v(" "+_vm._s(_vm.$t('label.not_found'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }